import React from "react";
import FormLocalDemande from "../components/elements/informationsLocal/FormLocalDemande";
import FormLocalSurface from "../components/elements/informationsLocal/FormLocalSurface";
import Checkbox from "../components/UI/Checkbox";
import Divider from "../components/UI/Divider";
import Header from "../components/UI/Header";
import RadioGroup from "../components/UI/RadioGroup";
import Select from "../components/UI/Select";
import {
  optionsLocalCopro,
  optionsStatutDemandeur,
} from "../utils/selectOptions";

const InformationsLocal = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
  ville,
  CP,
}) => {
  return (
    <>
      <Header title="3. Informations sur le local" />
      <FormLocalDemande
        formData={formData}
        handleChange={handleChange}
        inputFocus={inputFocus}
        handleTrimValue={handleTrimValue}
        ville={ville}
      />
      <Divider />
      <section>
        <Select
          label="L'immeuble est-il en copropriété ?"
          selectClassName={"page-3-required"}
          name="LocCopro"
          value={formData.LocCopro}
          handleChange={handleChange}
          inputFocus={inputFocus}
          options={optionsLocalCopro}
          datagroup="LocCopro"
          isBold={true}
        />
        {formData.LocCopro === "Oui" && (
          <>
            <div className="row pt-4">
              <div className="col-12 position-relative">
                <label htmlFor="LocAdrNumLot" className="form-label fw-bold">
                  N° de lot(s) (pour les immeubles en copropriété)
                  <span className="text-danger">(facultatif)</span>&nbsp;:&nbsp;
                </label>
                <input
                  className="form-control LocCopro-group page-3-required inputReg getLabel"
                  type="text"
                  id="LocAdrNumLot"
                  name="LocAdrNumLot"
                  value={formData.LocAdrNumLot || ""}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required={formData?.LocCopro === "Oui"}
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
            <Checkbox
              label="J'atteste que le réglement de copropriété du local ne s'oppose pas au changement d'usage demandé."
              checkClassName="page-3-required LocCopro-group"
              name="Check5"
              value="J'atteste que le réglement de copropriété du local ne s'oppose pas au changement d'usage demandé."
              checked={
                formData.Check5 ===
                "J'atteste que le réglement de copropriété du local ne s'oppose pas au changement d'usage demandé."
              }
              handleChange={handleChange}
              inputFocus={inputFocus}
            />
          </>
        )}
        {(formData.LocCopro ===
          "Oui, mais la copropriété n'est pas organisée" ||
          formData.LocCopro === "Je ne sais pas") && (
          <div className="alert alert-info mt-4">
            <i className="fas fa-info-circle"></i>&nbsp;
            <strong>Pour information :</strong>&nbsp;Nous vous rappelons que la
            loi impose à toute copropriété d'être organisée, c'est-à-dire
            qu'elle doit posséder des documents de gestion (règlement intérieur,
            tantièmes, assurances, ...) et des organes de gestion (Syndic,
            conseil syndical). Nous vous invitons à vous rapprocher des services
            municipaux dans le cadre du Programme Opérationnel de Prévention et
            d'Accompagnement en Copropriétés (POPAC) qui sera lancé début 2025
            et qui a vocation à accompagner gratuitement les copropriétés dans
            leur organisation et dans la résorption de leurs difficultés
            financières.
          </div>
        )}
      </section>
      <Divider />
      <RadioGroup
        label="Avez-vous acquis le local dans le cadre d’une accession à la propriété à prix maitrisée ?"
        inputClassName={"page-3-required"}
        name="LocPrimoAccess"
        value_1="Oui"
        value_2="Non"
        handleChange={handleChange}
        inputFocus={inputFocus}
        checked_1={formData.LocPrimoAccess === "Oui"}
        checked_2={formData.LocPrimoAccess === "Non"}
      />
      <Divider />
      {formData.LocCopro !== "Non, car il s'agit d'une monopropriété" && (
        <>
          <section>
            <RadioGroup
              inputClassName={"page-3-required"}
              label="Le local se situe-t-il en rez-de-chaussée ?"
              name="LocRezChau"
              value_1={"Oui"}
              value_2={"Non"}
              handleChange={handleChange}
              inputFocus={inputFocus}
              checked_1={formData.LocRezChau === "Oui"}
              checked_2={formData.LocRezChau === "Non"}
              datagroup={"LocRezChau"}
            />
            {formData.LocRezChau === "Non" && (
              <div className="row mt-4">
                <div className="col-12 position-relative">
                  <label htmlFor="LocEtage" className="form-label fw-bold">
                    A quel étage est situé le local&nbsp;?&nbsp;
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control page-3-required LocRezChau-group inputReg getLabel"
                    type="text"
                    pattern="[0-9]+"
                    name="LocEtage"
                    id="LocEtage"
                    maxLength={2}
                    value={formData.LocEtage || ""}
                    onChange={handleChange}
                    onInput={inputFocus}
                    onBlur={handleTrimValue}
                    required={formData.LocRezChau === "Non" ? true : false}
                  />
                  <div className="invalid-tooltip">
                    Veuillez entrer un numéro d'étage valide
                  </div>
                </div>
              </div>
            )}
          </section>
          <Divider />
        </>
      )}
      <Select
        selectClassName={"page-3-required"}
        label="Statut du demandeur :"
        name={"LocMandantStatut"}
        value={formData.LocMandantStatut}
        options={optionsStatutDemandeur}
        handleChange={handleChange}
        inputFocus={inputFocus}
        datagroup={"LocMandantStatut"}
        isBold={true}
      />
      <Divider />
      <FormLocalSurface
        formData={formData}
        handleChange={handleChange}
        inputFocus={inputFocus}
        handleTrimValue={handleTrimValue}
      />
      <Divider />
      <RadioGroup
        inputClassName={"page-3-required"}
        label="Votre local fait-il l'objet d'un conventionnement (logements conventionnés APL, les logements conventionnés ANAH (agence nationale de l'habitat)) ?"
        name="LocConv"
        value_1={"Oui"}
        value_2={"Non"}
        handleChange={handleChange}
        inputFocus={inputFocus}
        checked_1={formData.LocConv === "Oui"}
        checked_2={formData.LocConv === "Non"}
      />
      <Divider />
      <section>
        <RadioGroup
          inputClassName={"page-3-required"}
          label="Le local appartient-il à un bailleur social ?"
          name="LocBailSos"
          value_1={"Oui"}
          value_2={"Non"}
          handleChange={handleChange}
          inputFocus={inputFocus}
          checked_1={formData.LocBailSos === "Oui"}
          checked_2={formData.LocBailSos === "Non"}
          datagroup={"LocBailSos"}
        />
        {formData.LocBailSos === "Oui" && (
          <div className="row pt-4">
            <div className="col-12 position-relative">
              <label htmlFor="LocNomBail" className="form-label fw-bold">
                Nom du bailleur social&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                className="form-control page-3-required LocBailSos-group getLabel"
                type="text"
                name="LocNomBail"
                id="LocNomBail"
                value={formData.LocNomBail || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
        )}
      </section>
      <Divider />
      <section>
        <RadioGroup
          label="Le local fait-il l'objet d'une déclaration ou autorisation d'urbanisme ?"
          name="LocDemandeUrbaOuiNon"
          value_1={"Oui"}
          value_2={"Non"}
          handleChange={handleChange}
          inputFocus={inputFocus}
          checked_1={formData.LocDemandeUrbaOuiNon === "Oui"}
          checked_2={formData.LocDemandeUrbaOuiNon === "Non"}
          datagroup={"LocDemandeUrbaOuiNon"}
          isNotRequired={true}
        />
        {formData.LocDemandeUrbaOuiNon === "Oui" && (
          <div className="row background--warning p-4 mt-4">
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="LocDemandeUrbaNumero" className="form-label">
                Numéro de la demande&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                className="form-control page-3-required LocDemandeUrbaOuiNon-group getLabel"
                type="text"
                name="LocDemandeUrbaNumero"
                id="LocDemandeUrbaNumero"
                value={formData.LocDemandeUrbaNumero || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onBlur={handleTrimValue}
                required
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            <div className="col-12 col-md-6 position-relative">
              <label htmlFor="LocDemandeUrbaDate" className="form-label">
                Date de dépôt&nbsp;:&nbsp;
                <span className="text-danger">*</span>
              </label>
              <input
                className="form-control page-3-required LocDemandeUrbaOuiNon-group getLabel"
                type="date"
                name="LocDemandeUrbaDate"
                id="LocDemandeUrbaDate"
                value={formData.LocDemandeUrbaDate || ""}
                onChange={handleChange}
                onInput={inputFocus}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                required
              />
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
          </div>
        )}
      </section>
      <Divider />
      <section>
        <RadioGroup
          label="Le local est-il issu de la division d'un lot de copropriété ou d'un logement ?"
          name="LocCoproDivision"
          value_1={"Oui"}
          value_2={"Non"}
          handleChange={handleChange}
          inputFocus={inputFocus}
          checked_1={formData.LocCoproDivision === "Oui"}
          checked_2={formData.LocCoproDivision === "Non"}
          isNotRequired={true}
          datagroup={"LocCoproDivision"}
        />
        {formData.LocCoproDivision === "Oui" && (
          <div className="background--warning p-4 mt-3">
            <div className="row">
              <div className="col-12 col-md-6 position-relative pb-4">
                <label htmlFor="LocSurfaceInit" className="form-label">
                  Superficie initiale du local&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control page-3-required LocCoproDivision-group inputReg getLabel"
                  type="text"
                  pattern="[0-9]+"
                  id="LocSurfaceInit"
                  name="LocSurfaceInit"
                  value={formData.LocSurfaceInit || ""}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onBlur={handleTrimValue}
                  required
                  placeholder="ex: 20, 30, 30.5"
                />
                <div className="invalid-tooltip">
                  Veuillez entrer une superficie valide (ex: 30, 40, 30.5)
                </div>
              </div>
              <div className="col-12 col-md-6 position-relative">
                <label htmlFor="LocDateDivision" className="form-label">
                  Date de la division&nbsp;:&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control page-3-required LocCoproDivision-group date getLabel"
                  type="date"
                  id="LocDateDivision"
                  name="LocDateDivision"
                  value={formData.LocDateDivision || ""}
                  onChange={handleChange}
                  onInput={inputFocus}
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  required
                />
                <div className="invalid-tooltip">
                  Veuillez remplir ce champs obligatoire
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <Divider />
      <div className="row mt-5">
        <div className="col-12 position-relative">
          <label htmlFor="LocRefCadastre" className="form-label fw-bold">
            Référence cadastrale (au format préfixe - section - N° de
            parcelle)&nbsp;:&nbsp;
            <span className="text-danger">*</span>
          </label>
          <input
            className="form-control page-3-required getLabel"
            type="text"
            id="LocRefCadastre"
            name="LocRefCadastre"
            value={formData.LocRefCadastre || ""}
            onChange={handleChange}
            onInput={inputFocus}
            onBlur={handleTrimValue}
            placeholder="section composée de 2 lettres suivi du numéro composé de 4 chiffres - exemple: HM0133"
            required
          />
          <p className="subtext">
            La référence cadastrale d'un bien immobilier correspond à sa
            désignation sur le plan cadastral. Si vous ne connaissez pas la
            référence cadastrale de votre local, rendez-vous sur le site{" "}
            <a
              href="https://www.cadastre.gouv.fr/scpc/accueil.do"
              target="blank"
              rel="nofollow"
            >
              www.cadastre.gouv.fr
            </a>
            {" - "}
            (lien vers le site{" "}
            <a href="https://www.geoportail.gouv.fr/" target="blank">
              Géoportail
            </a>
            ).
          </p>
          <div className="invalid-tooltip">
            Veuillez remplir ce champs obligatoire
          </div>
        </div>
      </div>
    </>
  );
};

export default InformationsLocal;
